<template>
  <!-- Duo-Diptychon "Zwei Seiten, ein Quiz-Match": zwei Menschen, verbunden
               durch das Wellen-Motiv der Seite — sie spielen das Quiz-Match nach,
               das Markenzeichen von Viluu. Rein dekorativ (aria-hidden), ohne JS
               laeuft Runde 1 per CSS und endet im vollstaendigen Match-Tableau. -->
  <div class="k-duo kq-run" aria-hidden="true">
    <svg class="kd-line" viewBox="0 0 640 360" preserveAspectRatio="none" fill="none">
      <defs>
        <linearGradient id="kdGrad" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stop-color="#F17C08" />
          <stop offset="1" stop-color="#C63E7C" />
        </linearGradient>
      </defs>
      <path d="M-30 240 C 160 60, 420 340, 670 120" stroke="url(#kdGrad)" stroke-width="14" stroke-linecap="round" />
    </svg>
    <span class="kd-t kd-l"><span class="kd-face"><img :src="img('stephan')" alt="" width="260" height="320" decoding="async"></span></span>
    <span class="kd-t kd-r"><span class="kd-face"><img :src="img('sophia')" alt="" width="260" height="320" decoding="async"></span></span>
    <span class="kq-q"><span class="dot"></span><span class="kq-qt">Berge oder Meer?</span></span>
    <span class="kq-a kq-al">Meer</span>
    <span class="kq-a kq-ar"><span class="kd-dots"><i></i><i></i><i></i></span><span class="kq-at">Meer</span></span>
    <span class="kq-c">
            <span class="kq-halo"></span>
            <span class="kq-b"><span class="kq-bi"><svg viewBox="0 0 24 24" fill="url(#kdGrad)" aria-hidden="true"><use href="#viluu-heart" /></svg><em>Quiz Match!</em></span></span></span>
  </div>
</template>

<script>
import { profileImg } from './profiles';

export default {
  name: 'KennenlernenQuizDuo',
  methods: {
    img: profileImg,
  },
};
</script>
